import { render, staticRenderFns } from "./performanceReport_KSA_new.vue?vue&type=template&id=d7a1be22&"
import script from "./performanceReport_KSA_new.vue?vue&type=script&lang=js&"
export * from "./performanceReport_KSA_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports